import { LoadingButton } from "@mui/lab"
import { CircularProgress, Grid, MenuItem, TextField, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import toast from "react-hot-toast"
import { useDispatch, useSelector } from "react-redux"
import { urlapi } from "../../lib/backend/data"
import { cerrarSesion } from "../../redux/actions/session"

const FormularioReconocimientoFacial = (props) => {
    const [ configuracion, setConfiguracion ] = useState(false)
    const [ loading, setLoading ] = useState(true)
    const [ loadingGuardado, setLoadingGuardado ] = useState(false)
    const dispatch = useDispatch()
    const sesion = useSelector((state) => state.miusuario)

    const handleChange = (e) => {
        const { name, value } = e.target
        configuracion[name] = value
        return setConfiguracion(configuracion)
    }

    const obtenerConfiguracion = async (tipo, subtipo) => {
        setLoading(true);
        return fetch(`${urlapi}/configuracion/tipo?tipo=${tipo}&subtipo=${subtipo}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer: ${sesion.tokenSession}`,
        },
        })
        .then((res) => {
            if (res.status === 401) return dispatch(cerrarSesion());
            return res.json();
        })
        .then((res) => {
            console.log(res)
            if (!res) {
                toast.error('Sin datos');
                return setLoading(false);
            } else if (res.errorMessage) {
                toast.error(res.errorMessage);
                return setLoading(false);
            } else if (res._id) {
                setConfiguracion(res)
            }
            return setLoading(false);
        })
        .catch((error) => {
            toast.error('Error al consultar la información, intente nuevamente');
            return setLoading(false);
        })
    }
    
    const actualizarConfiguracion = async () => {
        setLoadingGuardado(true);
        return fetch(`${urlapi}/configuracion`, {
        method: 'PUT',
        body: JSON.stringify(configuracion),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer: ${sesion.tokenSession}`,
        },
        })
        .then((res) => {
            if (res.status === 401) return dispatch(cerrarSesion());
            return res.json();
        })
        .then((res) => {
            console.log(res)
            if (!res) {
                toast.error('Sin datos');
                return setLoadingGuardado(false);
            } else if (res.errorMessage) {
                toast.error(res.errorMessage);
                return setLoadingGuardado(false);
            } else if (res._id) {
                toast.success("Guardado exitosamente")
            }
            return setLoadingGuardado(false);
        })
        .catch((error) => {
            toast.error('Error al consultar la información, intente nuevamente');
            return setLoadingGuardado(false);
        })
    }

    useEffect(() => {
        obtenerConfiguracion("conductores","validacion_fotografica")
    }, [])

    if(loading) return <div><CircularProgress /></div>

    return <div>
        <Typography variant='h5' sx={{ mb:1 }} >Reconocimiento facial </Typography>
        <Grid container spacing={1}>
            <Grid item md={6} xs={12}>
                <TextField
                    id="outlined-select-currency"
                    select
                    label="Reconocimiento facial"
                    sx={{ mb: 2 }}
                    fullWidth
                    name="nombre"
                    defaultValue={configuracion.nombre}
                    onChange={handleChange}
                    >
                    <MenuItem value="allow_always">No solicitar</MenuItem>
                    <MenuItem value="every_time">Solicitar siempre</MenuItem>
                    <MenuItem value="specific_times">Solicitar veces por día</MenuItem>
                </TextField>
            </Grid>
            <Grid item md={6} xs={12}>
                <TextField
                  label='Número de veces al día'
                  variant='filled'
                  name='numero'
                  fullWidth
                  defaultValue={configuracion.numero}
                  onChange={handleChange}
                />
              </Grid>
            <Grid item md={12} xs={12}>
            <LoadingButton
                    sx={{ width: "100%" }}
                    loading={loadingGuardado}
                    loadingPosition="start"
                    variant="outlined"
                    color="success"
                    onClick={() => actualizarConfiguracion()}
                    >
                     GUARDAR CAMBIOS
                </LoadingButton>
              </Grid>
        </Grid>
    </div>
}

export default FormularioReconocimientoFacial